module.exports = _.every;